var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPhone(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12.04,
    viewBox: "0 0 15.044 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.179 8.274a2.375 2.375 0 01-.506-.091 7.126 7.126 0 01-.989-.294 1.51 1.51 0 00-1.872.755l-.166.34a9.2 9.2 0 01-2.008-1.511 9.2 9.2 0 01-1.51-2.008l.317-.211A1.51 1.51 0 007.2 3.382a7.8 7.8 0 01-.294-.989 5.66 5.66 0 01-.091-.513A2.265 2.265 0 004.55 0H2.286A2.265 2.265 0 00.018 2.574 14.343 14.343 0 0012.492 15h.287a2.259 2.259 0 002.265-2.272V10.46a2.265 2.265 0 00-1.865-2.186zm.377 4.529a.755.755 0 01-.257.566.793.793 0 01-.619.189A12.833 12.833 0 011.576 2.4a.823.823 0 01.189-.619.755.755 0 01.566-.257h2.265a.755.755 0 01.755.6q.045.31.113.611a8.4 8.4 0 00.347 1.17l-1.057.491a.755.755 0 00-.37 1 10.938 10.938 0 005.284 5.284.8.8 0 001-.393l.468-1.057a10.335 10.335 0 001.193.347q.3.068.611.113a.755.755 0 01.6.755z",
    fill: "#1053ff"
  })));
}

export default SvgPhone;